/* Sikara wishlist — localStorage, no app.
   Any element with data-wishlist-toggle="<product-handle>" becomes a heart toggle.
   Any element with data-wishlist-count shows the live item count.
   The wishlist page section reads SikaraWishlist.all() and renders cards. */
(function () {
  window.SikaraWishlist = {
    key: 'sikara_wishlist',
    all: function () {
      try { return JSON.parse(localStorage.getItem(this.key)) || []; } catch (e) { return []; }
    },
    save: function (arr) {
      try { localStorage.setItem(this.key, JSON.stringify(arr)); } catch (e) {}
      this.refresh();
    },
    has: function (h) { return this.all().indexOf(h) > -1; },
    toggle: function (h) {
      var arr = this.all(), i = arr.indexOf(h);
      if (i > -1) { arr.splice(i, 1); } else { arr.push(h); }
      this.save(arr);
      return i === -1;
    },
    remove: function (h) {
      var arr = this.all(), i = arr.indexOf(h);
      if (i > -1) { arr.splice(i, 1); this.save(arr); }
    },
    refresh: function () {
      var arr = this.all();
      var hearts = document.querySelectorAll('[data-wishlist-toggle]');
      for (var i = 0; i < hearts.length; i++) {
        var on = arr.indexOf(hearts[i].getAttribute('data-wishlist-toggle')) > -1;
        hearts[i].classList.toggle('wl-on', on);
        hearts[i].setAttribute('aria-pressed', on ? 'true' : 'false');
        hearts[i].innerHTML = on ? '&#9829;' : '&#9825;';
      }
      var counts = document.querySelectorAll('[data-wishlist-count]');
      for (var j = 0; j < counts.length; j++) {
        counts[j].textContent = arr.length;
        counts[j].style.display = arr.length ? '' : 'none';
      }
    }
  };

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('[data-wishlist-toggle]') : null;
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    SikaraWishlist.toggle(btn.getAttribute('data-wishlist-toggle'));
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { SikaraWishlist.refresh(); });
  } else {
    SikaraWishlist.refresh();
  }
})();
